<div class="auth-wrapper">
  <div class="auth-content">
      <div class="auth-bg"><span  class="r"></span><span class="r s"></span><span class="r s"></span><span class="r"></span></div>



    <form class="card" (submit)="onSubmit($event)">
      <dx-form class="card-body text-center" [formData]="formData" [disabled]="loading">



        <dxi-item dataField="icon" class="icon" editorType="dxTextBox">
          <div  class="mb-2"><i class="fa fa-user fa-2x"></i><h3>Giriş</h3>
          </div>
        <dxo-label [visible]="false"></dxo-label>
      </dxi-item>


        <dxi-item dataField="email"  editorType="dxTextBox"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Eposta', mode: 'email' }">
          <dxi-validation-rule type="required" message="Email girin"></dxi-validation-rule>
          <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
          <dxo-label [visible]="false"></dxo-label>
        </dxi-item>

        <dxi-item dataField="password" editorType="dxTextBox" class="form-control"
          [editorOptions]="{ stylingMode: 'filled', placeholder: 'Şifre', mode: 'password' }">
          <dxi-validation-rule type="required" message="Şifre girin"></dxi-validation-rule>
          <dxo-label [visible]="false"></dxo-label>
        </dxi-item>

        <dxi-item dataField="rememberMe" editorType="dxCheckBox"
          [editorOptions]="{ text: 'Beni Hatırla', elementAttr: { class: 'form-text' } }">
          <dxo-label [visible]="false"></dxo-label>
        </dxi-item>

        <dxi-item itemType="button">
          <dxo-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'signInTemplate'">
          </dxo-button-options>
        </dxi-item>

        <dxi-item>
          <div class="link">
            <a routerLink="/reset-password">Şifremi Unuttum</a>
          </div>
        </dxi-item>

        <!-- <dxi-item itemType="button">
          <dxo-button-options text="Create an account" width="100%" [onClick]="onCreateAccountClick"></dxo-button-options>
        </dxi-item> -->

        <ng-container *dxTemplate="let item of 'signInTemplate'">
          <div>
            <span class="dx-button-text">
              <ng-container *ngIf="loading; else notLoading">
                <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
              </ng-container>
              <ng-template #notLoading>GİRİŞ</ng-template>
            </span>
          </div>
        </ng-container>

      </dx-form>
    </form>
  </div>
</div>
